export const replaceAroundStep = () => {
  // Skip for now.
};
